import React from 'react';

// Tab bar per shared-docs/frontend-architecture.md + ux-requirements.md:
//   - role="tablist" on container, role="tab" + aria-selected on each tab.
// `tabs` is an array of { value, label }. `activeTab` is the current value.
export default function TabBar({ tabs, activeTab, onChange, className = '' }) {
  return (
    <div
      role="tablist"
      className={[
        'inline-flex items-center gap-1 p-1 rounded-lg bg-gray-100 dark:bg-night-surface',
        className,
      ].join(' ')}
    >
      {tabs.map((tab) => {
        const selected = tab.value === activeTab;
        return (
          <button
            key={tab.value}
            role="tab"
            aria-selected={selected}
            onClick={() => onChange(tab.value)}
            className={[
              'px-3 py-1.5 rounded-md text-sm font-medium transition-colors',
              selected
                ? 'bg-white dark:bg-night-card text-gray-900 dark:text-night-text shadow-sm'
                : 'text-gray-600 dark:text-night-muted hover:text-gray-900 dark:hover:text-night-text',
            ].join(' ')}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
